import UpdateLeadPage from './UpdateLeadPage';

export default UpdateLeadPage;
